import * as React from "react";
import { Table, Typography } from "antd";
import { IReport3Applicant } from "../../../model/report/Report3Applicant";
import Report3DatesGrid from "../report/Report3DatesGrid";

const Report3Preview = ({
  translate,
  data,
  title,
  subtitle
}: {
  translate?: any;
  data: IReport3Applicant[];
  title?: string;
  subtitle?: string;
}) => {
  const columns = [
    {
      title: translate("document_template.applicant_id"),
      dataIndex: "applicantId",
      key: "applicantId"
    },
    {
      title: translate("document_template.party_id"),
      dataIndex: "partyId",
      key: "partyId"
    },
    {
      title: translate("document_template.first_name"),
      dataIndex: "firstName",
      key: "firstName"
    },
    {
      title: translate("document_template.father_name"),
      dataIndex: "fatherName",
      key: "fatherName"
    },
    {
      title: translate("document_template.last_name"),
      dataIndex: "lastName",
      key: "lastName"
    },
    {
      title: translate("document_template.mother_surname"),
      dataIndex: "motherSurname",
      key: "motherSurname"
    },
    {
      title: translate("document_template.submit_reason"),
      dataIndex: "submitReason",
      key: "submitReason"
    },
    {
      title: translate("document_template.submited_reports_number"),
      dataIndex: "submitedReportsNumber",
      key: "submitedReportsNumber",
      align: "right" as "right"
    },
    {
      title: translate("document_template.submit_dates"),
      key: "submitDates",
      render: (record) => {
        return (
          record.submitDates &&
          record.submitDates.length !== 0 && (
            <Report3DatesGrid
              dates={(record.submitDates || []).map((date: string) => {
                return { date: date.trim() };
              })}
            />
          )
        );
      }
    }
  ];
  return (
    <div>
      {title && (
        <Typography.Title style={{ fontSize: 14 }}>
          {`${translate("reports.params.reporting_period")}: ${title}`}
        </Typography.Title>
      )}
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {`${translate("reports.report")}: ${subtitle}`}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
      />
    </div>
  );
};

export default Report3Preview;
